<template>
  <div class="box mt-0 px-0">
    <v-layout
      class="wrapper text-xs-center"
      :style="{ 'min-height': `${minHeight}px` }"
      align-center
      justify-center
      fill-height
      row
    >
      <span>
        {{ $t('Common.genericErrorMsg') }}<br>
        <a
          :title="$t('Common.tryAgain')"
          class="text--link accent--text"
          @click.prevent="loadData"
        >
          {{ $t('Common.tryAgain') }}.
        </a>
      </span>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ErrorState',
  props: {
    minHeight: {
      type: Number,
      default: 422
    }
  },
  methods: {
    loadData () {
      this.$emit('loadData')
    }
  }
}
</script>
